export default __webpack_public_path__ + "static/media/image4.93db42e4.png";